'use strict';

export default {
    capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    },

    nl2br(str) {
        var regex = /(\r\n|\n\r|\r|\n)/g;
        str = '' + str;

        return (str.split(regex).map((line, index) => {
            return (line.match(regex) ? document.createElement('BR').outerHTML : line);
        }).join(''));
    },

    /**
     * Removes a string in a query object’s value which
     * might have pipez.
     *
     * @arg1 needle:Object
     * @arg2 queryObject:Object
     *
     * @returns queryObject:Object
     *
     * @example ( { foo: 'foo' }, { foo: 'foo|bar|baz', baz: 'bar' } ) => { foo: 'bar|baz', baz: 'bar' }
     */
    removeFromPipedQuery( needle, queryObject ) {
        var _query = {...queryObject};
        var value  = '';

        Object.keys( needle ).map(( key )=>{
            value = _query[key];

            // only perform this on piped values
            if ( ! /\|/.test( value ) ) {
                return;
            }

            _query[key] = value.split('|').map(component => component.replace(needle[key], '')).join('|').replace(/\|{2,}/, '|').replace(/^\||\|$/, '');
            if ( _query[key].length === 0 ) {
                delete _query[key];
            }
        });

        return _query;
    }
};



// WEBPACK FOOTER //
// ./app/utils/strings.js